import React from 'react';
import { ReportOutageSource } from '../../../__generated__/pge-types';
import { useTranslation } from '../../../hooks/useTranslation';
import { CONSTANTS } from '../constants';
import { RestorationStatusCodes, RestorationStatusInfo } from '../types';
import ReactMarkdown from 'react-markdown/with-html';

export const useReportOutageUtils = () => {
  const getRequestSource = () => {
    return ReportOutageSource.Web;
  };

  return {
    getRequestSource,
  };
};

export const getRestorationStatus = (status: string): RestorationStatusInfo => {
  const { t, inlineRichT } = useTranslation();

  const STATUS_INFO: Record<
    RestorationStatusCodes,
    { title: string; description: React.ReactNode }
  > = {
    [RestorationStatusCodes.POWER_OUT]: {
      title: t('RESTORATION_FAQ_Q1'),
      description: (
        <ReactMarkdown
          source={t('RESTORATION_A1')}
          escapeHtml={false}
          linkTarget={'_blank'}
        />
      ),
    },
    [RestorationStatusCodes.WERE_ON_IT]: {
      title: t('RESTORATION_FAQ_Q2'),
      description: inlineRichT('RESTORATION_FAQ_A2'),
    },
    [RestorationStatusCodes.MORE_HELP_NEEDED]: {
      title: t('RESTORATION_FAQ_Q3'),
      description: inlineRichT('RESTORATION_FAQ_A3'),
    },
    [RestorationStatusCodes.REPAIRS_IN_PROGRESS]: {
      title: t('RESTORATION_FAQ_Q4'),
      description: inlineRichT('RESTORATION_FAQ_A4'),
    },
    [RestorationStatusCodes.WRAPPING_UP]: {
      title: t('RESTORATION_FAQ_Q5'),
      description: inlineRichT('RESTORATION_FAQ_A5'),
    },
    [RestorationStatusCodes.MAINTENANCE_IN_PROGRESS]: {
      title: t('RESTORATION_FAQ_Q6'),
      description: inlineRichT('RESTORATION_FAQ_A6'),
    },
    [RestorationStatusCodes.POWER_RESTORED_PLANNED]: {
      title: t('RESTORATION_FAQ_Q7'),
      description: inlineRichT('RESTORATION_FAQ_A7'),
    },
    [RestorationStatusCodes.MAINTENANCE_PLANNED]: {
      title: t('RESTORATION_MAINTENANCE_PLANNED'),
      description: t('RESTORATION_MAINTENANCE_PLANNED_INFO'),
    },
  };

  //Dynamically build the map: code -> enum value
  const map: Record<string, RestorationStatusCodes> = Object.entries(
    CONSTANTS.RESTORATION_STATUSES,
  ).reduce((acc, [key, codes]) => {
    const statusCode = Number(key) as RestorationStatusCodes;
    codes.forEach(code => {
      // normalize to uppercase to be safe
      acc[code.toUpperCase()] = statusCode;
    });
    return acc;
  }, {} as Record<string, RestorationStatusCodes>);

  return status && map[status.trim().toUpperCase()]
    ? STATUS_INFO[map[status.trim().toUpperCase()]]
    : STATUS_INFO[RestorationStatusCodes.POWER_OUT];
};

export function clearAllQueryParams() {
  // 1. Create a URL object from the current window location
  const url = new URL(window.location.href);

  // 2. Set the 'search' property to an empty string to remove all params
  url.search = '';

  // 3. Update the browser's URL without reloading the page
  // This will also remove the trailing '?'
  window.history.replaceState({}, document.title, url.toString());
}
